import { Hand } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * The indigo "Claim" quick-action: grab an open thread (or an unclaimed task) from the shared
 * queue. Outline at rest, fills solid indigo on hover. Reused by thread-row hover actions,
 * board cards (full-width) and Tasks-page rows.
 * @param {object} props
 * @param {() => void} props.onClick
 * @param {string} [props.className]
 * @param {string} [props.label]
 * @param {string} [props.title]
 */
export function ClaimButton({ onClick, className, label = "Claim", title }) {
  return (
    <button
      type="button"
      title={title || "Claim — it's yours, your avatar shows for the whole team"}
      onClick={(event) => {
        // Inside a thread-row <Button>: claiming must not also open the conversation.
        event.stopPropagation();
        onClick?.();
      }}
      className={cn(
        "inline-flex items-center justify-center gap-1 rounded-md border border-indigo-200 bg-indigo-50 px-2 py-[3px] text-[10.5px] font-semibold leading-none text-indigo-700 transition",
        "hover:border-indigo-600 hover:bg-indigo-600 hover:text-white",
        "dark:border-indigo-500/40 dark:bg-indigo-950/60 dark:text-indigo-200 dark:hover:border-indigo-500 dark:hover:bg-indigo-600 dark:hover:text-white",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
    >
      <Hand className="h-3 w-3 shrink-0" strokeWidth={2.5} aria-hidden />
      {label}
    </button>
  );
}
